import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=7195ac8c&scoped=true&"
import script from "./Rate.vue?vue&type=script&lang=js&"
export * from "./Rate.vue?vue&type=script&lang=js&"
import style0 from "./Rate.vue?vue&type=style&index=0&id=7195ac8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7195ac8c",
  null
  
)

export default component.exports